import React, { useState,useMemo,useEffect,useRef} from 'react';
import Pagination from './Pagination';
import "./DataGrid.css";
import SearchableVehicleSelect from './SearchableVehicleSelect'
import DetailComponent from './DetailComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {buildGetWebformRoutingDetails} from './XmlBuildFunctions';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { faMap } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'; 
const ITEMS_PER_PAGE = 50;

const DataGrid = ({ rowData,vehicleData,vehiclechanged }) => {
  const [currentPage, setCurrentPage] = useState(1); 
  const [expandedRowId, setExpandedRowId] = useState(null); 
  const [detailData, setdetailData] = useState([]);
  const totalItems=rowData.length;
  const intervals = useRef({}); 
  const [activeBTN, setactiveBTN] = useState({});

  const currentData = useMemo(() => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE; 
    return rowData.slice(startIndex, endIndex);
  }, [rowData, currentPage]);
  
  const handlePageChange = (page) => {
    if (page >= 1 && page <= Math.ceil(totalItems / ITEMS_PER_PAGE)) {
        setCurrentPage(page);
        setExpandedRowId(null);
    }
  }; 

  const handleToggleDetails = (id) => {  
    setExpandedRowId(id === expandedRowId ? null : id);   

    if(window.config.isXMLAPI){ 
          try {  
              let allRoutingsDetailData = [];  
              const xhr = new XMLHttpRequest();
              const url = window.config.API_URL_BO;
              xhr.open('POST', url, true);  
              xhr.setRequestHeader('Content-Type', 'text/xml');
              xhr.onload = function () { 
              if (xhr.status >= 200 && xhr.status < 300) { 
                  const xmlString = xhr.responseText;
                  const parser = new DOMParser();
                  const xmlDoc = parser.parseFromString(xmlString, 'text/xml');   
                  const itemElements = xmlDoc.getElementsByTagName('RoutingDetail'); 
                  for (let i = 0; i < itemElements.length; i++) { 
                      const item = itemElements[i];   
                      allRoutingsDetailData.push({'id':i,'PickupPoint':item.getAttribute('PickupPoint'),'PickupDate':item.getAttribute('PickupDate'),
                      'Flight':item.getAttribute('Flight'),'PickupTime':item.getAttribute('PickupTime'),'RefNumber':item.getAttribute('RefNumber'),
                      'Client':item.getAttribute('Client'),'Hotel':item.getAttribute('Hotel'),'PAX':item.getAttribute('PAX'),'participants':item.getAttribute('participants')});
                  }   
                  setdetailData(allRoutingsDetailData); 
              } else {  
              }
              };
              
              xhr.send(buildGetWebformRoutingDetails(id));   
               
          } catch (e) {
              console.error("Failed to fetch details:", e);
              alert('Failed to load details. Please check the console.');
          } finally { 
          }
        }else{
              try {  
                  axios.get(window.config.API_URL_BO+"Assignment/RoutingDetails/" +id , { 
                        })
                        .then(response => { 
                           if (response.status === 200) { 

                                let allRoutingsDetailData = [];   
                                response.data.forEach((item,index) => {

                                    allRoutingsDetailData.push({'id':index,'PickupPoint':item.PickupPoint,'PickupDate':item.PickupDate,
                                    'Flight':item.Flight,'PickupTime':item.PickupTime,'RefNumber':item.RefNumber,
                                    'Client':item.Client,'Hotel':item.Hotel,'PAX':item.PAX,'participants':item.participants});
                                    
                                });
                                
                                if (allRoutingsDetailData.length > 0){  
                                    setdetailData(allRoutingsDetailData);
                                } 
                           }else{
                                console.error('Request failed error status:', response.status);
                           } 
                        })
                        .catch(error => {
                        console.error('Request failed:', error); 
                        });  
                } catch (err) {
                     console.error("API Polling Error:", err);  
                } finally {  
                }
        }
  }; 
     
  
   const getUserLocation = (ordernum,platename,client) => { 
    if (navigator.geolocation) { 

        const locationOptions = {
          enableHighAccuracy: true,
          maximumAge: 0 
        };

        navigator.geolocation.getCurrentPosition(
        (position) => { 
          const { latitude, longitude } = position.coords;  
          try {  
                   axios.post(window.config.API_URL_FO+"Coordinates/"+ordernum+"/"+client+"/" +platename +"/"+latitude+"/"+longitude , { 
                        })
                        .then(response => {  
                           if (response.status === 200) {    
                            console.log("writing coordinates..");
                           }else{
                                console.error('Request failed error status:', response.status);
                                clearInterval(intervals.current[ordernum]);
                                delete intervals.current[ordernum]; 
                                setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
                           } 
                        })
                        .catch(error => {
                                        console.error('Request failed:', error); 
                                        clearInterval(intervals.current[ordernum]);
                                        delete intervals.current[ordernum]; 
                                        setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
                        });  
                } catch (err) {
                     console.error("API Polling Error:", err);  
                     clearInterval(intervals.current[ordernum]);
                     delete intervals.current[ordernum];  
                     setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
                } finally {  
                }
        }, 
        (error) => {
          console.error('Error getting user location:', error);
          clearInterval(intervals.current[ordernum]);
          delete intervals.current[ordernum]; 
          setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
        },
        locationOptions
      );
    } 
    else {
      console.error('Geolocation is not supported by this browser.');
      clearInterval(intervals.current[ordernum]);
      delete intervals.current[ordernum]; 
      setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
    }
  };

  const sendcoordinates=(ordernum,plateid) =>{ 
    if (activeBTN[ordernum]){ 
      setactiveBTN(prev => ({ ...prev, [ordernum]: false }));
      if (intervals.current[ordernum]) {
        clearInterval(intervals.current[ordernum]);
        delete intervals.current[ordernum]; 
      }
    }else{
     // if (intervals.current[ordernum]) return; 
      const plate = vehicleData.find(item => parseInt(item.id) === parseInt(plateid));  
      const platename = plate.name;
      const client = localStorage.getItem('AccountID');  
    
      intervals.current[ordernum] = setInterval(() => {
        getUserLocation(ordernum,platename, client)
      }, 5000);
      setactiveBTN(prev => ({ ...prev, [ordernum]: true }));
    }
     
  }

  useEffect(() => { 
    return () => {
      Object.values(intervals.current).forEach(clearInterval);
    };
  }, []);

  let lastDate = null; 
  const isAdmin = localStorage.getItem('isAdmin'); 

  const mappopup=(ordernum) => {
    const url = new URL(window.location.href);
    const baseUrl = url.origin;
    window.open(baseUrl+'/livetrafficstatus?ordernum='+ordernum, '_blank', 'noopener,noreferrer');
  }

  const checkDateRange = (dateFrom) => {
   
              const [day, month, year] = dateFrom.split('/').map(Number);
              const targetDate = new Date(year, month-1, day);  
              const today = new Date(); 
              const yesterday = new Date(today);
              yesterday.setDate(today.getDate() - 1);
              yesterday.setHours(0, 0, 0, 0); 
              const tomorrow = new Date(today);
              tomorrow.setDate(today.getDate() + 1); 
              tomorrow.setHours(23, 59, 59, 999); 
              return targetDate >= yesterday && targetDate <= tomorrow;
  };
  
  return (
    
    <div className="data-grid-container">
   
      <table className='table-class'>
        <colgroup>
          <col style={{ width: '50px' }} /> 
        </colgroup>
        <thead>
          <tr>
            <th style={{ width: '50px' }}></th> 
            <th>OrderNum</th>
            <th></th>
            <th></th>
            <th>Origin</th>
            <th>Destination</th>
            <th>Route</th>
            <th>PickUp Time</th>
            <th>PAX</th>
            <th>Transfer Type</th> 
            <th>Vehicle</th>
            <th>Arrival Flight</th>
            <th>Departure Flight</th>
            <th>Flight Time</th>
            <th>TourOperator</th>
            <th>Comments</th>
          </tr>
        </thead>
        <tbody> 
           {currentData.map(item => {
              
          let dateHeader = null;
          const columnCount = 2;   
          if (item.Datefrom !== lastDate) { 
              dateHeader = (
                  <tr key={`header-${item.Datefrom}`} className="group-header">
                        <td colSpan={columnCount}>
                         <FontAwesomeIcon icon={faCalendarDays} /> {item.Datefrom}  
                        </td>
                  </tr>
              ); 
            lastDate = item.Datefrom;
            }
            return( 
            <React.Fragment key={item.OrderNum}> 
            {dateHeader}
              <tr>
                <td>
                  <button 
                    onClick={() => handleToggleDetails(item.OrderNum)}
                    style={{ cursor: 'pointer', border: 'none', background: 'none' }}
                  >
                    {item.OrderNum === expandedRowId ? <FontAwesomeIcon icon={faChevronDown} size="sm" color="#5A6A7D" />: <FontAwesomeIcon icon={faChevronRight} size="sm" color="#5A6A7D" />}
                  </button>
                </td>
                <td>{item.OrderNum}</td>
                <td>
                  <>
                    {isAdmin==='true' && (
                      <FontAwesomeIcon onClick={() => mappopup(item.OrderNum)}  className='famap' icon={faMap} />
                    )}
                  </>
                </td>
                <td>
                  <>
                    {item.Vehicle > 0 && checkDateRange(item.Datefrom) && (
                       <button 
                        onClick={() => sendcoordinates(item.OrderNum,item.Vehicle)}
                        className={activeBTN[item.OrderNum] ? "Stopbtn" : "startbtn"} 
                        >{activeBTN[item.OrderNum] ? "Stop" : "Start"}</button>
                    )}
                  </> 
                </td>
                <td>{item.Origin}</td>
                <td>{item.Destination}</td>
                <td>{item.Route}</td>
                <td>{item.PickUpTime}</td>
                <td>{item.PAX}</td>    
                <td>{item.TransferType}</td> 
                <td>
                    <SearchableVehicleSelect
                      initialVehicleValue={item.Vehicle}
                      vehicleData={vehicleData}
                      apifunction={vehiclechanged}
                      orderId={item.OrderNum}
                      autoFocus={false}
                    />
                </td>
                <td>{item.ArrivalFlight}</td>
                <td>{item.DepartureFlight}</td>
                <td>{item.DepartureTime}</td>
                <td>{item.TourOperator}</td>     
                 <td>{item.Comments}</td>     
              </tr> 
              {item.OrderNum === expandedRowId && (
                <tr className="detail-row-container">  
                  <td colSpan={9}>
                    <DetailComponent detailData={detailData}></DetailComponent>  
                  </td> 
                </tr> 
                
              )}
            </React.Fragment>
          )
        }
        )}
        </tbody>
      </table>
       
       <Pagination
        totalItems={totalItems}
        itemsPerPage={ITEMS_PER_PAGE}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />  

    </div>
  );
};

export default DataGrid;